import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ebb-portal-dialog-contractorproxy',
    templateUrl: './dialog-contractorproxy.component.html',
    styleUrls: ['./dialog-contractorproxy.component.scss'],
    standalone: false
})
export class DialogContractorProxyComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogContractorProxyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  public onClickConfirm(): void {
    this.dialogRef.close(true);
  }

  public onClickCancel(): void {
    this.dialogRef.close(false);
  }

}
